export const sceneModels = ['hero', 'robotics', 'ai', 'electronics', 'software'] as const;
export type LabModel = (typeof sceneModels)[number];
export type HeroTheme = Exclude<LabModel, 'hero'>;
export const heroThemes: HeroTheme[] = ['robotics', 'ai', 'electronics', 'software'];
export const heroThemeLabels: Record<HeroTheme, string> = {
  robotics: 'Робототехника', ai: 'Искусственный интеллект', electronics: 'Электроника', software: 'Программирование',
};

export const sceneScale: Record<LabModel, number> = {
  hero: .9, robotics: 1.32, ai: 1.2, electronics: 1.2, software: 1.2,
};

const files: Record<LabModel, string> = {
  hero: 'hero-v5', robotics: 'robotics-v7', ai: 'ai-v5', electronics: 'electronics-v5', software: 'software-v4',
};

export function sceneAsset(model: LabModel, extension: 'glb' | 'png') {
  return `/assets/home-lab-3d/${files[model]}.${extension}`;
}
